"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSO = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const subnameOfDomain = {
    development: '',
    test: 'login',
    staging: 'login-std',
    production: 'login',
};
function getLoginDomainByHost(host, env) {
    // Xử lý trường hợp localhost
    if (host.startsWith("localhost")) {
        return "http://localhost:3000";
    }
    // @ts-ignore
    return `https://${subnameOfDomain[env]}.${host.split('.').slice(-2).join('.')}`;
}
function addPrefixDomain(domain) {
    if (!domain)
        return 'localhost';
    if (domain.startsWith('localhost'))
        return 'localhost';
    return `.${domain.split('.').slice(-2).join('.')}`;
}
function storeData(domain, credentials) {
    const expireDate = new Date();
    const maxAge = 7 * 24 * 60 * 60; // 7 days
    expireDate.setTime(expireDate.getTime() + maxAge * 1000);
    console.log('domain', domain);
    const options = {
        path: "/",
        domain: addPrefixDomain(domain),
        expires: expireDate,
        maxAge,
    };
    console.log('options', options);
    js_cookie_1.default.set('AccessToken', credentials.AccessToken, options);
    js_cookie_1.default.set('IdToken', credentials.IdToken, options);
    js_cookie_1.default.set('RefreshToken', credentials.RefreshToken, options);
    localStorage.setItem('AccessToken', credentials.AccessToken);
    localStorage.setItem('RefreshToken', credentials.RefreshToken);
    localStorage.setItem('IdToken', credentials.IdToken);
}
class SSO {
    constructor(env) {
        this.env = env;
        this.whitelist = [
            "localhost",
            "30shine.org",
            "30shine.com",
            "moyo.vn",
            "goidauda.net",
            "mrlionbarber.com",
            "mrlionbarber.org"
        ];
    }
    redirectToDomainTarget(path = '') {
        const { href, host } = window.location;
        const loginDomain = getLoginDomainByHost(host, this.env);
        window.location.replace(`${loginDomain}${`/${path}`}?redirect=${href}`);
    }
    ssoLogin() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // Check whitelist domain
                if (!this.whitelist.some((item) => window.location.hostname.indexOf(item) > -1)) {
                    throw new Error("Host invalid");
                }
                // Get cookie: AccessToken, IdToken, RefreshToken
                const AccessToken = js_cookie_1.default.get('AccessToken');
                const IdToken = js_cookie_1.default.get('IdToken');
                const RefreshToken = js_cookie_1.default.get('RefreshToken');
                // Handle redirect login
                if (!AccessToken) {
                    if (RefreshToken) {
                        const credentials = yield this.refreshToken();
                        if (credentials) {
                            // storeData(window.location.host, credentials)
                            return credentials;
                        }
                    }
                    // not login
                    console.log('Handle redirect login');
                    this.redirectToDomainTarget();
                    return false;
                }
                return {
                    AccessToken,
                    IdToken,
                    RefreshToken
                };
            }
            catch (error) {
                console.log('Handle redirect login - error: ', error);
                this.redirectToDomainTarget();
                return false;
            }
        });
    }
    ssoLogout() {
        this.redirectToDomainTarget();
        return false;
    }
    refreshToken() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { host } = window.location;
                const loginDomain = getLoginDomainByHost(host, this.env);
                const data = yield fetch(`${loginDomain}/api/refresh-token`, {
                    method: 'GET',
                    credentials: 'include'
                }).then((response) => response.json());
                if (data.success == 1)
                    return data;
                if (data.success == 0) {
                    this.redirectToDomainTarget();
                    return false;
                }
            }
            catch (error) {
                this.redirectToDomainTarget();
                return false;
            }
        });
    }
}
exports.SSO = SSO;
